"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _q = _interopRequireDefault(require("q"));

var _connectPromiseSingle = require("crm_data/flux/connectPromiseSingle");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _PortalAndUserAge = _interopRequireDefault(require("crm_internal/utils/PortalAndUserAge"));

var _ExtensionInstallHelpers = _interopRequireDefault(require("ExtensionInstallHelpers.SidekickExtensionInstallHelpers"));

var _requiredData = _interopRequireDefault(require("customer-data-tracking/constants/requiredData"));

var PORTAL_AGE_DAYS = _requiredData.default.PORTAL_AGE_DAYS,
    PORTAL_AGE_MONTHS = _requiredData.default.PORTAL_AGE_MONTHS,
    USER_AGE_DAYS = _requiredData.default.USER_AGE_DAYS,
    USER_AGE_MONTHS = _requiredData.default.USER_AGE_MONTHS,
    USAGE_PORTAL_FIRST_WEEK = _requiredData.default.USAGE_PORTAL_FIRST_WEEK,
    CHROME_EXTENSION_INSTALLED = _requiredData.default.CHROME_EXTENSION_INSTALLED,
    USER_WAS_INVITED = _requiredData.default.USER_WAS_INVITED;
var settingsStoreFetcher = (0, _connectPromiseSingle.connectPromiseSingle)(_SettingsStore.default, function (settings) {
  return !settings;
});

var getAgeProperties = function getAgeProperties() {
  var _ref;

  var agesPromise = _PortalAndUserAge.default.get();

  return _ref = {}, (0, _defineProperty2.default)(_ref, PORTAL_AGE_DAYS, function () {
    return agesPromise.then(function (ages) {
      return ages.getIn(['portal', 'days']);
    });
  }), (0, _defineProperty2.default)(_ref, PORTAL_AGE_MONTHS, function () {
    return agesPromise.then(function (ages) {
      return ages.getIn(['portal', 'months']);
    });
  }), (0, _defineProperty2.default)(_ref, USAGE_PORTAL_FIRST_WEEK, function () {
    return agesPromise.then(function (ages) {
      return ages.getIn(['user', 'days']) <= 7;
    });
  }), (0, _defineProperty2.default)(_ref, USER_AGE_DAYS, function () {
    return agesPromise.then(function (ages) {
      return ages.getIn(['user', 'days']);
    });
  }), (0, _defineProperty2.default)(_ref, USER_AGE_MONTHS, function () {
    return agesPromise.then(function (ages) {
      return ages.getIn(['user', 'months']);
    });
  }), _ref;
};

var getUserWasInvited = function getUserWasInvited() {
  return _q.default.Promise.all([settingsStoreFetcher(), _user.default]).then(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        settings = _ref3[0],
        userManager = _ref3[1];

    var creatorUserId = settings && settings.get('crm:signup:creator');
    var userId = userManager && userManager.get('user_id');
    return settings ? parseInt(creatorUserId, 10) !== userId : null;
  });
};

function get() {
  var _extends2;

  return (0, _extends3.default)({}, getAgeProperties(), (_extends2 = {}, (0, _defineProperty2.default)(_extends2, CHROME_EXTENSION_INSTALLED, _ExtensionInstallHelpers.default.hasExtension()), (0, _defineProperty2.default)(_extends2, USER_WAS_INVITED, getUserWasInvited), _extends2));
}